var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCouponCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 42,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 8.583A8.583 8.583 0 0 0 61.417 0H8.583A8.583 8.583 0 0 0 0 8.583V16.1a5.002 5.002 0 0 1 0 9.8v7.517A8.583 8.583 0 0 0 8.583 42h52.834A8.583 8.583 0 0 0 70 33.417V8.583Z"
})));
export default SvgCouponCard;